import React from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import { API } from '../api';
import favicon from '../assets/pictures/logo/source/latelier_floral_512x512.png';

export default function HeaderMeta() {

  const location = useLocation();
  const currentUrl = `${window.location.origin}${location.pathname}`;
  const currentYear = new Date().getFullYear();

  return (
    <Helmet>
      <meta charSet="UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
      <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
      <meta name="robots" content="index, follow" />
      <meta name="googlebot" content="index, follow" />
      <meta name="bingbot" content="index, follow" />
      <meta name="GPTBot" content="index, follow" />
      <meta name="ClaudeBot" content="index, follow" />
      <title>L’Atelier Floral | Fleuriste au Cap d'Agde</title>
      <meta httpEquiv="Content-Language" content="fr" />
      <meta name="language" content="fr" />
      <meta name="geo.region" content="FR" />
      <meta name="geo.placename" content="Cap d'Agde" />
      <meta name="author" content="L’Atelier Floral | Rina EGRY" />
      <meta name="copyright" content={`© ${currentYear} - Propriété de L’Atelier Floral • Tous droits réservés • Développé et Réalisé par HEG Développement • Hugo EGRY`} />
      <meta name="description" content="Bouquets, plantes et compositions florales pour tous vos événements. Votre fleuriste au Cap d’Agde." />
      <meta name="keywords" content="fleuriste, fleurs, bouquet, plantes, décoration florale, Cap d'Agde, arrangements floraux, événement" />

      <link rel="canonical" href={currentUrl} />

      {/* Open Graph */}
      <meta property="og:title" content="L’Atelier Floral | Fleuriste au Cap d'Agde" />
      <meta property="og:description" content="Bouquets, plantes et compositions florales pour tous vos événements. Votre fleuriste au Cap d’Agde." />
      {/* <meta 
        property="og:image" 
        content={`${baseUrl}/images/enteteImg/${headerParams.socialMediaImage}.${headerParams.socialMediaImageExtension}`} 
      /> */}
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="fr_FR" />
      <meta property="og:site_name" content="L’Atelier Floral" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="L’Atelier Floral | Fleuriste au Cap d'Agde" />
      <meta name="twitter:description" content="Bouquets, plantes et compositions florales pour tous vos événements. Votre fleuriste au Cap d’Agde." />
      {/* <meta 
        name="twitter:image" 
        content={`${baseUrl}/images/enteteImg/${headerParams.socialMediaImage}.${headerParams.socialMediaImageExtension}`} 
      /> */}

      {/* JSON-LD */}
      {/* <script type="application/ld+json">
        {headerParams.referencementSementique}
      </script> */}

      {/* Favicons */}
      {/* {`${API.API_LINK}/file/pictures/logo/latelier_floral_512x512.png`} */}
      <link rel="shortcut icon" type="image/png" sizes="any" href={favicon} />
      <link rel="shortcut icon" type="image/png" sizes="512x512" href={favicon} />
      {/*<link rel="shortcut icon" type="image/png" sizes="192x192" href="/images/iconnes/favicon/favicon192x192.png" />
      <link rel="shortcut icon" type="image/png" sizes="180x180" href="/images/iconnes/favicon/favicon180x180.png" />
      <link rel="shortcut icon" type="image/png" sizes="96x96" href="/images/iconnes/favicon/favicon96x96.png" />
      <link rel="shortcut icon" type="image/png" sizes="48x48" href="/images/iconnes/favicon/favicon48x48.png" />
      <link rel="shortcut icon" type="image/png" sizes="32x32" href="/images/iconnes/favicon/favicon32x32.png" />
      <link rel="shortcut icon" type="image/png" sizes="16x16" href="/images/iconnes/favicon/favicon16x16.png" />

      {/* Apple touch icons */}
      {/*
      <link rel="apple-touch-icon" sizes="180x180" href="/images/enteteImg/logo/png/logo_MRHE_Services180x180.png" />
      <link rel="apple-touch-icon" sizes="167x167" href="/images/enteteImg/logo/png/logo_MRHE_Services167x167.png" />
      <link rel="apple-touch-icon" sizes="152x152" href="/images/enteteImg/logo/png/logo_MRHE_Services152x152.png" />
      <link rel="apple-touch-icon" sizes="120x120" href="/images/enteteImg/logo/png/logo_MRHE_Services120x120.png" />
      <link rel="apple-touch-icon" sizes="76x76" href="/images/enteteImg/logo/png/logo_MRHE_Services76x76.png" />
      <link rel="apple-touch-icon" sizes="60x60" href="/images/enteteImg/logo/png/logo_MRHE_Services60x60.png" />
      <link rel="mask-icon" href="/images/enteteImg/logo/svg/logo_MRHE_Services512x512.svg" color="#5bbad5" /> */}

      <meta name="msapplication-TileColor" content="#ffffff" />
      {/* <meta name="msapplication-TileImage" content="/images/enteteImg/logo/png/logo_MRHE_Services144x144.png" /> */}
      <meta name="msapplication-config" content="public/xml/browserconfig.xml" />

      <meta name="theme-color" content="#e8c6d0" />
      <meta name="color-scheme" content="light dark" />
      <script src="https://kit.fontawesome.com/90dedf5486.js" crossorigin="anonymous" defer></script>

    </Helmet>
  );
};